import { Box } from "@chakra-ui/react";

interface AppPageContentProps {
    children: JSX.Element;
}

export const AppPageContent = ({ children }: AppPageContentProps) => {
    return (
        <>
            <Box flex="1" overflow="auto">
                {children}
            </Box>
        </>
    );
};
